<div class="container-base">
  <mat-card>
    <mat-card-title>
      <img src="{{logoSrc}}" alt="logo" class="logo" />
    </mat-card-title>
    <mat-card-subtitle>{{title}}</mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field class="full-width-input">
          <input matInput class="lowercase" placeholder="{{ 'labels.username' | translate }}" formControlName="username" required autofocus />
          <mat-error>{{ 'errors.required.username' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width-input">
          <input matInput class="lowercase" placeholder="{{ 'labels.email' | translate }}" formControlName="email" required />
          <mat-error *ngIf="email.hasError('required')">{{ 'errors.required.email' | translate }}</mat-error>
          <mat-error *ngIf="email.hasError('email')">{{ 'errors.invalid.email' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width-input">
          <input matInput placeholder="{{ 'labels.name' | translate }}" formControlName="name" required />
          <mat-error>{{ 'errors.required.name' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width-input">
          <mat-select placeholder="{{ 'labels.language' | translate }}" formControlName="language">
            <mat-option *ngFor="let lang of languages" [value]="lang.value">
              {{lang.viewValue}}
            </mat-option>
          </mat-select>
          <mat-error>{{ 'errors.required.language' | translate }}</mat-error>
        </mat-form-field>

        <mat-error class="invalid-form" *ngIf="invalid">{{ 'errors.invalid.registration' | translate }}</mat-error>
        <button mat-raised-button [disabled]="!form.valid" color="primary">{{ 'buttons.register' | translate }}</button>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <a class="login-link" routerLink="/login">{{ 'labels.alreadyHaveAccount' | translate }}</a>
    </mat-card-footer>
  </mat-card>
</div> 